import React, { Fragment, Component } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { BookOpen, FileText, Beaker, RefreshCw, Zap } from 'lucide-react';
export function PeptideMasteryComponent() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const protocols = ['Liver Regeneration', 'Kidney Repair', 'Bone Healing', 'Accelerated Healing', 'Regenerate Spinal Discs', 'Traumatic Brain Injury Recovery', 'Stroke Recovery', "Alzheimer's Disease Regeneration", "Parkinson's Disease Regeneration", 'Cognitive Decline / Brain Fog Solution', 'Improve Speed of Learning and Memory Retention', 'ADHD Calm Focus Protocol', 'Anti-Anxiety', 'Mood Enhancement and Depression Relief', 'Anhedonia Fix & Pleasure Re-Sensitization', 'Addiction Support Stack', 'Diabetes Control', 'Fix Hypothyroidism', 'Male Hormone Optimization', 'Female Hormone Optimization', 'Low Energy and Chronic Fatigue Fix', 'Stubborn Fat Loss and Muscle Gain Enhancement', 'Ultimate Heart Protocol', 'Blood Vessel and Artery Support', 'Anemia Fix', 'Immune System Fortification', 'Autoimmune Support', 'Cancer Recovery Support', 'Biological Age Reversal', 'Elderly Lifespan Stack', 'Skin Rejuvenation', 'Hair Growth and Health', 'Lung Power', 'Ultimate Cold Tolerance', 'Ultimate Anti-Hypoxiant', '"Hold Your Breath for Longer" Protocol', 'Radiation Resilience and Recovery Regimen', 'Athletic Performance Enhancement', 'Military Personnel Protocol', 'Chronic Pain Management', 'Neuropathy Support', 'Chronic Prostatitis Cure', 'Eye Health and Vision Enhancement', 'Reverse Hearing Loss', 'Restore Olfaction', 'Digestive Health', 'Reverse Gum Disease and Periodontitis', 'Sleep Optimization', 'Supercharged Libido Stack', 'Enhanced Tanning Protocol', 'Pregnancy Symptom Relief', "Huntington's Disease Recovery", 'Duchenne Muscular Dystrophy or Spinal-Bulbar Muscular Atrophy Healing', 'Sarcopenia Recovery'];
  return <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-black" data-id="element-3266">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto" data-id="element-3267">
        <div className="text-center mb-12 sm:mb-16" data-id="element-3268">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-stone-100 mb-6 sm:mb-8" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-3269">
            54 Precision Protocols
          </h2>
          <p className="text-lg sm:text-xl text-stone-400 max-w-3xl mx-auto" data-id="element-3270">
            Included in Peptide Mastery 2.0. Each protocol is a complete,
            step-by-step roadmap for specific biological optimization goals.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-3271">
          {protocols.map((protocol, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={inView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.4,
          delay: index * 0.02
        }} className="bg-stone-900/40 border border-stone-800 p-4 rounded-lg flex items-start gap-3 hover:border-amber-500/30 transition-colors" data-id="element-3272">
              <FileText className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-3273" />
              <span className="text-stone-300 text-sm sm:text-base" data-id="element-3274">
                {protocol}
              </span>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}